<template> 
  <div class="content" style="overflow-y: auto;">
    <div class="search-area">
      <el-row :gutter="24">
        <el-col :span="7" >
        <div class="search-area-div">岗位：</div>
          <el-select v-model="page.positionGuid" filterable class="ipt-sty fl" placeholder="请选择">
            <el-option
              v-for="item in positionList"
              :key="item.guid"
              :label="item.positionName"
              :value="item.guid">
            </el-option>
          </el-select>
          </el-col>   
          <el-col  :span="7" class="t-left"> 
            <el-button size="medium" type="info" @click="getData(true)">搜索</el-button>
          </el-col>
          </el-row> 
    </div>  
  <!-- <div class="fl back-color-fff borderR6" style="width: 15.6%;padding-bottom:15px">
  <el-input
  placeholder="输入关键字进行过滤"
  v-model="filterText" style="width: 80%; margin-top:10px;">
</el-input>

<el-tree
    :data="superiorOrganization"  
    ref="treess"
    class="mt10 mb10"
    nodeKey="guid"
    highlight-current
    :current-node-key="organisationGuid"
    :filter-node-method="filterNode"
    :props="defaultPropsOrganisation"
    @node-click="handleNodeCilck"
  >
  </el-tree>
  </div> -->

  <div>
    <div class="button-area">
      <el-button icon="el-icon-plus" size="medium" type="info" @click="add(1, '')">新增人员</el-button>
      <el-button size="medium" type="danger" @click="getDeleteData(1, '')">批量删除</el-button>
      <div class="fr line-h40 h40 font-S16 mr16">{{staffName}}，有<b class="fontC-4fa1a4"> {{page.totalRows}} </b>个备案岗位</div>
      <!-- <el-button plain size="medium">历史数据</el-button> -->
    </div>
    <div class=" back-color-fff p16" >
      <el-table :data="tableData" @selection-change="handleSelectionChange" border style="width: 100%;" v-loading="tableLoading">
        <el-table-column type="selection" width="60" header-align="center" align="center"></el-table-column>
        <el-table-column label="序号" width="60" header-align="center" align="center">
          <template slot-scope="scope">
            <!-- {{ scope.$index + 1 }} -->
            {{(page.pageIndex - 1) * page.pageSize + scope.$index + 1}}
          </template>
        </el-table-column>
        <el-table-column prop="staffName" label="姓名" header-align="left" align="left"></el-table-column> 
        <el-table-column
          prop="mobileNo"
          label="手机号"
          header-align="left"
          align="left"
        ></el-table-column> 
        <el-table-column
          prop="logonUser"
          label="账号"
          header-align="left"
          align="left"
        ></el-table-column>
        <el-table-column label="操作" header-align="center" width="150" align="center" fixed="right">
          <template slot-scope="scope">
            <!-- <a class="txt-color" @click="add(2, scope.row)">编辑 | </a> -->
            <a class="txt-color-red" @click="getDeleteData(2, scope.row.guid)">删除</a>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      class="pt pb back-color-fff"
       style="padding: 16px;" 
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 100, 200]"
      :current-page="page.pageIndex"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.totalRows"
    >
    </el-pagination>
</div>

    <el-dialog :title="textTitle" :visible.sync="dialogFormVisible" width="51%">
      <el-form>
        <el-form-item label="*岗位名称:">
          <el-select v-model="positionGuid" filterable class="ipt-sty fl" placeholder="请选择">
            <el-option
              v-for="item in positionList"
              :key="item.guid"
              :label="item.positionName"
              :value="item.guid">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form> 
      <el-transfer
        filterable 
        class="fl"
        style="width:100%;margin-bottom:15px;"
        filter-placeholder="请输入人名检索"
        :titles="['全部人员', '已选人员']"
        v-model="staffGuids"
        :props="{ key: 'guid', label: 'staffName'}"
        :data="personnelList">
      </el-transfer>
      <div slot="footer" class="dialog-footer t-right">
        <el-button plain size="medium" @click="dialogFormVisible = false">取消</el-button>
        <el-button size="medium" type="info" @click="submitDepartment()" v-loading.fullscreen.lock="fullscreenLoading">确定</el-button>
      </div>
    </el-dialog>
  </div> 
</template>

<script>
import areaJson from '../../assets/js/china_address_v4.js';
import citys from '../../components/citys.vue';
export default {
    components:{
    citys,
  },
  data() {
    return { 
      staffName:'',
      textTitle: '',
      right: '',
      dialogVisible: false,
      dialogFormVisible: false,
      formLabelWidth: '120px',
      positionList:[], 
      positionGuid:'',
      defaultPropsOrganisation:{
           id: "guid",
           label: "organisationName",
           children:"children"
        },   
      page: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: '',
        logonUser: '',
        staffName: '',
        mobileNo: '',
        staffType: '2',
        bizState: 'Y', 
        positionGuid:'',
        sendTenantGuid:'',
        positionGiuds:[],
      },
      staffDetail:'',
      tableData: [], 
      filterText: '',
      multipleSelection: [],
      tableLoading:false,
      tenantList: [],
      addressOptions: areaJson,
      operationUnitList: [],
      fullscreenLoading: false,
      personnelList:[],
      staffGuids:[],
    };
  },
  watch: {
      filterText(val) {
        this.$refs.tree.filter(val);
      }
    },
  created() {
    // 列表
    this.staffName = this.$route.query.tenantName;
    this.getPosition();
  },
  methods: {  
    handleNodeCilck(data){
      // console.log(data);
      let self = this;
      self.page.organisationGuid = data.guid;
      self.getData(true);
      // node.
    },
    //获取岗位下拉框
    getPosition() { 
      let self = this;
      let promise = {
        pageIndex:1,
        pageSize:-1,
        tenantGuid:self.$route.query.tenantGuid,
      }
      self.api.postJson(`/${serverConfig.msPersonnelService}/position/data/get`,promise).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.positionList = res.data.data.records;
          if(self.positionList){
            self.positionGuid = self.positionList[0].guid;
            self.page.positionGuid = self.positionList[0].guid;
            self.$nextTick(function(){
              self.getData(true);
            })
          } 
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    
    filterNode(value, data) {
        if (!value) return true;
        return data.organisationName.indexOf(value) !== -1;
      },
    empty() {
      let self = this;
      self.page = {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: '',
        logonUser: '',
        staffName: '',
        mobileNo: '',
        staffType: '1',
        bizState: 'Y', 
        positionGuid:'',
        positionGiuds:[],
        tenantGuid:self.$store.getters.getTenantGuid,
        sendTenantGuid:self.$route.query.tenantGuid
      };
      self.getData(true);
    },
    add(flg, row) {
      let self = this;
      self.roleGuid = '';
      self.staffGuids = [];
      self.personnelList = [];
      if (flg == 1) {
        self.textTitle = '新增人员'; 
        self.getPersonnelList();  
        self.dialogFormVisible = true;
      }
    },
    getPersonnelList() {
      let self = this;
      let promse = {
        tenantGuid: self.$store.getters.getTenantGuid,
        sendTenantGuid: self.$route.query.tenantGuid,
        pageIndex:1,
        pageSize:-1,
        staffType:2
      }
      self.api.postJson(`/${serverConfig.msPersonnelService}/staff/data/get`, promse).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.personnelList = res.data.data.records; 
          if(self.personnelList){
            self.personnelList.forEach((i)=>{
              i.staffName = i.staffName + i.mobileNo
            })
          }
        } else {
          self.$message.error(res.data.msg);
        }
      });
    }, 
    getData(flg) {
      let self = this;
      if (flg) {
        self.page.pageIndex = 1;
      }
      self.page.tenantGuid = self.$store.getters.getTenantGuid;
      self.page.sendTenantGuid = self.$route.query.tenantGuid;  
      self.tableLoading = true;
      self.page.positionGiuds = [];
      if(self.page.positionGuid){
        self.page.positionGiuds.push(self.page.positionGuid);
      }
      self.api.postJson(`/${serverConfig.msPersonnelService}/staff/data/get`, self.page).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableLoading = false;
          self.tableData = res.data.data.records;
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    }, 
    handleSelectionChange(val) {
      let self = this;
      self.multipleSelection = [];
      val.forEach(function(item) {
        //item 就是当日按循环到的对象
        self.multipleSelection.push(item.guid);
      });
    },

    getDeleteData(flg, guid) {
      let self = this;
      if (flg == 1) {
        if (self.multipleSelection.length == 0) {
          self.$message.error('请勾选数据！');
          return;
        }
      } else {
        self.multipleSelection = [];
        self.multipleSelection.push(guid);
      }
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          self.api
            .postJson(`/${serverConfig.msPersonnelService}/staff/delete-staff-position-rel`,{'positionGuid':self.page.positionGuid,'staffGuids':self.multipleSelection})
            .then(res => {
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                self.multipleSelection = [];
                self.$message.success('删除人员成功');
                self.getData(true);
              } else {
                self.$message.error(res.data.msg);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },
    submitDepartment(){
      let self = this;
      if(!self.positionGuid){
        self.$message.error('请先选择岗位!');
        return
      }
      if(!self.staffGuids){
        self.$message.error('请勾选人员!');
        return
      }
      self.api.postJson(`/${serverConfig.msPersonnelService}/staff/add-staff-position-rel`,{'positionGuid':self.positionGuid,'staffGuids':self.staffGuids}).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.dialogFormVisible = false;
          self.tableLoading = false;
          self.$message.success('添加人员成功');
          self.getData(true);
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getData();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getData();
    },
    getLevel(val) { 
      let self = this;
      console.log('789',val,val.length);
      if(val.length > 0){ 
            self.ruleForm.organisationGuid = val[val.length-1].toString();
      }
      // console.log(self.ruleForm.level);
  }
  },
};
</script>
<style scoped>
.el-col-5 {
  width: 33%;
}
.ipt-sty{
  width: 69%!important;
}
/deep/.el-tree-node__label{
  width: 80%;
  white-space: normal;
  overflow: hidden;
  text-align: left;
}
/deep/ .el-transfer-panel {
    text-align: left;
    width: 33%; 
}
.el-tree-node__content{
  height: auto;
}
.radio-ora{
  margin-right: 12px;
} 
</style>
